module.exports = __webpack_public_path__ + "img/menu-24px.c6263b30.svg";